export default __webpack_public_path__ + "media/images/ie8-panel/warning_bar_0000_us-793734b103d99035ef76535c8ac9c9f5.jpg";